import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { GlassCard } from '@/components/brand/GlassCard';
import { GlowButton } from '@/components/brand/GlowButton';

export default function AdminLoginPage() {
    const startLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        // The post-auth target is always /admin (handled in AuthCallback) — no
        // browser storage involved, so admin access cannot be tampered with via
        // localStorage / sessionStorage.
        const redirectUrl = window.location.origin + '/admin';
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };
    return (
        <div className="bg-la-canvas text-la-text min-h-screen">
            <Navbar />
            <main className="pt-32 pb-24">
                <div className="max-w-md mx-auto px-4 sm:px-6">
                    <GlassCard className="p-8">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass text-[11px] tracking-[0.16em] uppercase text-la-text2">
                            <ShieldCheck className="h-3.5 w-3.5 text-la-gold" /> Admin Access
                        </div>
                        <h1 className="mt-5 font-display text-3xl text-la-text">Sign in to the firm console.</h1>
                        <p className="mt-3 text-sm text-la-text2 leading-relaxed">Use your Google account. Only allowlisted firm members will be granted access. The first admin to sign in is auto-approved on initial setup.</p>
                        <div className="mt-7">
                            <GlowButton onClick={startLogin} className="w-full justify-center" data-testid="admin-google-signin-button">
                                <GoogleMark /> Continue with Google <ArrowRight className="h-4 w-4" />
                            </GlowButton>
                        </div>
                        <p className="mt-6 text-[11px] text-la-text3">By signing in you agree to the firm&apos;s <Link to="/terms" className="underline-grow text-la-text2 hover:text-la-text">Terms</Link> and <Link to="/privacy" className="underline-grow text-la-text2 hover:text-la-text">Privacy Policy</Link>.</p>
                    </GlassCard>
                </div>
            </main>
            <Footer />
        </div>
    );
}

const GoogleMark = () => (
    <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true" className="inline-block">
        <path fill="#4285F4" d="M17.64 9.2a10.6 10.6 0 0 0-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.79 2.71v2.26h2.9c1.7-1.56 2.69-3.86 2.69-6.61Z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.46-.81 5.95-2.19l-2.9-2.26c-.8.54-1.83.86-3.05.86-2.34 0-4.32-1.58-5.03-3.7H.94v2.33A9 9 0 0 0 9 18Z"/>
        <path fill="#FBBC05" d="M3.97 10.71A5.4 5.4 0 0 1 3.68 9c0-.59.1-1.16.29-1.71V4.96H.94a9 9 0 0 0 0 8.08l3.03-2.33Z"/>
        <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.43 1.34l2.57-2.57C13.46.99 11.43 0 9 0A9 9 0 0 0 .94 4.96l3.03 2.33C4.68 5.16 6.66 3.58 9 3.58Z"/>
    </svg>
);
